<div class="z-filter-bar filter-bar">

  @if (chips.length) {
    @for (chip of visibleChips; track chip.key + '|' + chip.value) {
      <span class="z-chip-filter">
        <b>{{ chip.label }}:</b><span class="chip-text">{{ chip.text }}</span>
        <button class="chip-x"
                type="button"
                [attr.aria-label]="'Quitar el filtro ' + chip.label + ': ' + chip.text"
                (click)="removeChip(chip)">
          <i class="bi bi-x-lg" aria-hidden="true"></i>
        </button>
      </span>
    }

    @if (hiddenChipCount) {
      <button class="z-chip-filter chip-more"
              type="button"
              [attr.aria-label]="'Ver los ' + hiddenChipCount + ' filtros restantes'"
              (click)="openDrawer()">+{{ hiddenChipCount }}</button>
    }
  } @else {
    <span class="filter-empty">Sin filtros — mostrando todo el periodo</span>
  }

  <button #trigger
          class="z-btn z-btn--glass filter-open"
          type="button"
          aria-haspopup="dialog"
          [attr.aria-expanded]="open"
          (click)="openDrawer()">
    <i class="bi bi-sliders" aria-hidden="true"></i>
    <span>Filtros</span>
    @if (activeCount) {
      <span class="filter-count">{{ activeCount }}<span class="z-sr-only"> filtros activos</span></span>
    }
  </button>

</div>

@if (open) {

  <div class="z-drawer-backdrop" (click)="closeDrawer()"></div>

  <aside #drawer
         class="z-drawer"
         role="dialog"
         aria-modal="true"
         tabindex="-1"
         [attr.aria-labelledby]="titleId">

    <header class="drawer-head">
      <h2 class="drawer-title" [id]="titleId">Filtros</h2>
      <button class="z-modal-close drawer-close"
              type="button"
              aria-label="Cerrar el panel de filtros"
              (click)="closeDrawer()">
        <i class="bi bi-x-lg" aria-hidden="true"></i>
      </button>
    </header>

    <div class="z-drawer-body">
      @for (field of fields; track field.key) {
        <fieldset class="z-fieldset drawer-field" [class.z-fieldset--plain]="field.plain">
          <legend>{{ field.label }}</legend>

          @if (field.type === 'range') {
            <app-date-range
              [label]="field.label"
              [placeholder]="field.placeholder || 'dd/mm/aaaa – dd/mm/aaaa'"
              [value]="draftRango()"
              [min]="rangoMin"
              [max]="rangoMax"
              (valueChange)="onRangoChange($event)" />
          } @else {
            <app-multi-select
              [attr.data-field-label]="field.label"
              [options]="field.options"
              [selected]="draftFor(field.key)"
              [multiple]="field.type === 'multi'"
              [placeholder]="field.placeholder || 'TODOS'"
              (selectedChange)="onDraftChange(field.key, $event)" />
          }

          @if (avisoPeriodo(field); as aviso) {
            <p class="drawer-note">{{ aviso }}</p>
          }
        </fieldset>
      }

      @if (!fields.length) {
        <div class="z-empty">
          <i class="bi bi-funnel" aria-hidden="true"></i>
          <p>Esta sección no tiene filtros.</p>
        </div>
      }
    </div>

    <footer class="drawer-foot">
      <button class="z-btn z-btn--glass drawer-clear" type="button" (click)="clearAll()">
        <i class="bi bi-eraser" aria-hidden="true"></i> Limpiar todo
      </button>
      <button class="z-btn z-btn--purple" type="button" (click)="apply()">
        <i class="bi bi-check2" aria-hidden="true"></i> Aplicar
      </button>
    </footer>

  </aside>
}
